<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-cancel-onborading`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 13c0-3.314 2.69-6 6-6s6 2.686 6 6-2.69 6-6 6-6-2.686-6-6zm6-10c-5.52 0-10 4.477-10 10s4.48 10 10 10 10-4.477 10-10S26.52 3 21 3zM8.25 36c.89-3.45 4.02-6 7.75-6h8.05a1 1 0 001-1v-2a1 1 0 00-1-1H16C9.37 26 4 31.373 4 38v4c0 1.105.9 2 2 2h18.05a1 1 0 001-1v-2a1 1 0 00-1-1H8v-2c0-.691.09-1.361.25-2zm22.8-6.364l-1.414 1.414a1 1 0 000 1.415L33.172 36l-3.536 3.535a1 1 0 000 1.415l1.414 1.414a1 1 0 001.415 0L36 38.828l3.535 3.536a1 1 0 001.415 0l1.414-1.414a1 1 0 000-1.415L38.828 36l3.536-3.535a1 1 0 000-1.415l-1.414-1.414a1 1 0 00-1.415 0L36 33.172l-3.535-3.536a1 1 0 00-1.415 0z"/></svg>
</template>
<script>

export default {
  name: 'IconCancelOnborading',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
